import { createApi } from '@reduxjs/toolkit/query/react';
//
import { customBaseQuery } from '../../auth/context/jwt/utils';
import { IClient, IClientCreate, IClientPage } from '../../types/client';

const path = 'clients';

type UpdateProps = {
  data: IClientCreate;
  id: number;
};

export const clientService = createApi({
  reducerPath: 'clientService',
  tagTypes: ['clients'],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getClients: builder.query<IClientPage, Record<string, any>>({
      query: (params) => ({
        url: `/${path}/list`,
        params,
      }),
      providesTags: ['clients'],
    }),

    getClient: builder.query<IClient, number>({
      query: (id: number) => ({
        url: `/${path}/findById/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'clients', id }],
    }),

    getNextCode: builder.query<{ code: string }, void>({
      query: () => ({
        url: `/${path}/nextCode`,
        method: 'GET',
      }),
    }),

    saveClient: builder.mutation<IClient, IClientCreate>({
      query: (client: IClientCreate) => ({
        url: `/${path}/insert`,
        method: 'POST',
        body: client,
      }),
      invalidatesTags: ['clients'],
    }),

    updateClient: builder.mutation<IClient, UpdateProps>({
      query: ({ id, data }: UpdateProps) => ({
        url: `/${path}/update/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => ['clients', { type: 'clients', id }],
    }),

    deleteClient: builder.mutation<{ message: string }, number>({
      query: (id: number) => ({
        url: `/${path}/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['clients'],
    }),

    toggleClientStatus: builder.mutation<IClient, number>({
      query: (id: number) => ({
        url: `/${path}/${id}/toggle-status`,
        method: 'PATCH',
      }),
      invalidatesTags: ['clients'],
    }),
  }),
});

export const {
  useGetClientsQuery,
  useGetClientQuery,
  useLazyGetClientQuery,
  useGetNextCodeQuery,
  useSaveClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  useToggleClientStatusMutation,
} = clientService;
